import "../pages.scss"
import { RamosState } from '../../context/ramos/RamosState';
import Datatable from "./ramosTable/Datatable"

const RamosPage = () => {
  return (
    <>
      <RamosState>
        <Datatable />
      </RamosState>

    </>
  )
}

export default RamosPage